import React from 'react'
import ShippingButton from './ShippingButton';

const ShippingDetails = ({ order, onButtonClick }) => {
  return (
      <div className='col-span-3 my-auto'>
          <label htmlFor="username" className="pl-1 flex text-sm font-medium leading-6 text-gray-900 items-center">
              Shipping Detail
          </label>
          <div className='grid grid-cols-3 gap-2'>
              <ShippingButton 
                  isActive={order?.shipDetail === 'free'} 
                  label="Free" 
                  onClick={() => onButtonClick('free')} 
              />
              <ShippingButton 
                  isActive={order?.shipDetail === 'unknown'} 
                  label="ไม่รู้" 
                  onClick={() => onButtonClick('unknown')} 
              />
              <ShippingButton 
                  isActive={order?.shipDetail === 'cod'} 
                  label="COD" 
                  onClick={() => onButtonClick('cod')} 
              />
          </div>
      </div>
  );
}

export default ShippingDetails